import { render } from "./selectField.vue?vue&type=template&id=23503118&scoped=true&ts=true"
import script from "./selectField.vue?vue&type=script&lang=ts"
export * from "./selectField.vue?vue&type=script&lang=ts"

import "./selectField.vue?vue&type=style&index=0&id=23503118&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23503118"]])

export default __exports__